import { Component } from "react";
import RouteMenuButton from "./RouteMenuButton";
import Cookies from "universal-cookie";
import { MdAdsClick, MdCalendarViewWeek, MdOutlineCalendarMonth, MdOutlineSettings, MdOutlineTroubleshoot } from "react-icons/md";

export default class MainMenu extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
    }

    render() {
        return <>
            {(this.user.isAdmin || this.user.isCoordenador || this.user.isAnalista) && <RouteMenuButton icon={
                <MdOutlineCalendarMonth size={24} />
            } to="/semestral" index>Inventário</RouteMenuButton>}
            <RouteMenuButton icon={
                <MdCalendarViewWeek size={24} />
            } to="/semanal">Contagem Semanal</RouteMenuButton>
            {(this.user.isAdmin || this.user.isCoordenador || this.user.isAnalista) && <>
                <RouteMenuButton icon={
                    <MdOutlineTroubleshoot size={24} />
                } to="/apuracao">Apuração</RouteMenuButton>
            </>}
            {this.user.isAdmin && <RouteMenuButton icon={
                <MdOutlineSettings size={24} />
            } to="/ajustes">Ajustes</RouteMenuButton>}
        </>
    }
}